'use client'

import { useEffect } from 'react'
import { SUPABASE_PUBLIC_URL } from '@/lib/supabase-config'

const PRECONNECT_DOMAINS = [
  'https://fonts.googleapis.com',
  'https://fonts.gstatic.com',
  SUPABASE_PUBLIC_URL,
  'https://cdnjs.cloudflare.com',
]

const FONT_AWESOME_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css'

const enableServiceWorker =
  process.env.NEXT_PUBLIC_ENABLE_SERVICE_WORKER === 'true'

/**
 * Client component that handles runtime resource bootstrapping:
 * - Preconnect hints for external domains
 * - Font Awesome CSS injection
 * - Conditional service worker registration
 */
export function ResourceBootstrap() {
  useEffect(() => {
    // Preconnect to external domains
    for (const domain of PRECONNECT_DOMAINS) {
      if (!domain || document.querySelector(`link[href="${domain}"]`)) continue
      const link = document.createElement('link')
      link.rel = 'preconnect'
      link.href = domain
      link.crossOrigin = 'anonymous'
      document.head.appendChild(link)
    }

    // Load Font Awesome CSS
    if (!document.querySelector('link[href*="font-awesome"]')) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = FONT_AWESOME_URL
      link.crossOrigin = 'anonymous'
      document.head.appendChild(link)
    }

    // Conditionally register service worker
    if (enableServiceWorker && 'serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then(
        (registration) => {
          console.log('Service Worker registered:', registration.scope)
        },
        (error) => {
          console.error('Service Worker registration failed:', error)
        }
      )
    }
  }, [])

  return null
}
